import { CardTitle } from 'src/shared/components/ui/cards/card'
import { cn } from 'src/shared/utils/cn'

const AuthTitle = ({ title, className }: { title: string; className?: string }) => {
  return (
    <CardTitle
      className={cn('mb-1 mt-5 text-center text-[26px] font-semibold tracking-[-0.26px] md:text-[32px]', className)}
    >
      {title}
    </CardTitle>
  )
}

export default AuthTitle
